import { useTranslation } from "react-i18next";
import Notice from "components/tw/notice";
import { btnSecondaryCls } from "components/tw/classes";

/** A light placeholder for the list while the first answer is on its way. */
export function QueueSkeleton() {
  return (
    <div data-testid="queue-skeleton" aria-busy="true" className="animate-pulse space-y-2">
      {[0, 1, 2].map((row) => (
        <div key={row} className="h-12 rounded-lg bg-gray-100" />
      ))}
    </div>
  );
}

/** Shown when the list could not be loaded; a list that was already on the screen stays under it. */
export function LoadFailedNotice({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation();
  return (
    <Notice tone="critical" title={t("queue_load_failed")}>
      <button type="button" className={btnSecondaryCls} onClick={onRetry}>
        {t("queue_retry")}
      </button>
    </Notice>
  );
}
